import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DrawSignature"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5506 5.66465C22.5506 6.06071 22.3932 6.44053 22.113 6.72044L12.0676 16.7658H7.28484V11.983L17.3302 1.93767C17.6101 1.65745 17.9899 1.5 18.386 1.5C18.7821 1.5 19.1619 1.65745 19.4418 1.93767L22.113 4.60885C22.3932 4.88876 22.5506 5.26858 22.5506 5.66465ZM21.0949 5.63437L18.4163 2.95572L16.1778 5.19414L18.8565 7.87279L21.0949 5.63437ZM8.77724 15.2735V12.5949L15.1995 6.17261L17.8782 8.85125L11.4559 15.2735H8.77724ZM2.99228 18.8655C2.99228 20.7309 4.1115 21.0077 5.97685 21.0077H21.5071V22.5H5.97685C3.36535 22.5 1.5 21.477 1.5 18.8655C1.5 16.254 3.36535 15.231 5.97685 15.231H6.10138V16.7233H5.97685C4.1115 16.7233 2.99228 17.0002 2.99228 18.8655Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DrawSignature.vue"]]);
